import React, { useEffect } from "react";
import { Instagram } from "lucide-react";
import { SOCIAL } from "@/lib/social";

const LIGHTWIDGET_SRC = "https://cdn.lightwidget.com/widgets/lightwidget.js";

export default function InstagramFeed() {
  useEffect(() => {
    if (document.querySelector(`script[src="${LIGHTWIDGET_SRC}"]`)) return;
    const s = document.createElement("script");
    s.src = LIGHTWIDGET_SRC;
    s.async = true;
    document.body.appendChild(s);
  }, []);

  return (
    <section className="section-y bg-bone" data-testid="instagram-feed">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-12">
          <div className="max-w-2xl">
            <span className="label-eyebrow">— Latest from Instagram</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-heading font-semibold tracking-tight leading-[1.1] text-balance">
              "Make sex ed cool again."
            </h2>
            <p className="mt-5 text-ink/65 leading-relaxed">
              Follow <span className="text-ink font-medium">@aoturoa.academy.nz</span> for consent kōrero, myth-busting,
              and stories from our kaupapa.
            </p>
          </div>
          <a
            href={SOCIAL.instagram}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="instagram-follow-btn"
            className="btn-crimson self-start md:self-end"
          >
            <Instagram className="w-4 h-4" /> Follow on Instagram
          </a>
        </div>

        <div className="rounded-3xl overflow-hidden border border-stone bg-white p-2 sm:p-3">
          <iframe
            title="Aotūroa Academy Instagram"
            data-testid="instagram-widget"
            src="https://cdn.lightwidget.com/widgets/4df3f61734605b5ba12bd96a28e5d49d.html"
            scrolling="no"
            allowTransparency="true"
            className="lightwidget-widget w-full"
            style={{ border: 0, overflow: "hidden", minHeight: "560px" }}
          />
        </div>
      </div>
    </section>
  );
}
